const BASIC_TAB = {
  text: 'Basic',
  value: 'basic',
  contents: [
    {
      title: 'Basic Display',
      sections: [
        {
          description: 'Display raw values from the system (e.g. purchaser name, price, status)',
          examples: [
            {
              title: 'Example 1: Pull primary purchaser name',
              syntax: 'Name: {P1_Name}',
              output: 'Name: Ali bin Abu',
            },
            {
              title: 'Example 2: Pull primary purchaser address',
              syntax: '{P1_Address1}\n{P1_Address2}\n{P1_Postcode} {P1_City}\n{P1_State}',
              output: 'No 33 Lorong 5\nTaman Bunga Flora\n43500 Gopeng\nPerak',
            },
          ],
        },
      ],
    },
    {
      title: 'Formatting',
      sections: [
        {
          description: 'Text decorations like bold, italic, underline, colors, and etc can be apply directly from template file',
          examples: [
            {
              title: 'Uppercase',
              syntax: 'Name: {P1_Name | upper}',
              output: 'Name: ALI BIN ABU',
            },
            {
              title: 'Lowercase',
              syntax: 'Name: {P1_Name | lower}',
              output: 'Name: ali bin abu',
            },
            {
              title: 'Title Case',
              syntax: '{P1_Name | title}',
              output: 'Name: Ali Bin Abu',
            },
          ],
        },
        {
          description: 'Text decorations like bold, italic, underline, colors, and etc can be apply directly from template file',
          examples: [
            {
              title: 'Bold',
              syntax: 'Name: <b>{P1_Name}</b>',
              output: 'Name: <b>Ali Bin Abu</b>',
            },
            {
              title: 'Italic',
              syntax: 'Name: <i>{P1_Name}</i>',
              output: 'Name: <i>Ali Bin Abu</i>',
            },
            {
              title: 'Underline',
              syntax: 'Name: <u>{P1_Name}</u>',
              output: 'Name: <u>Ali bin Abu</u>',
            },
          ],
        },
      ],
    },
    {
      title: 'Number Format',
      sections: [
        {
          description: 'Format number/price with a commas and decimal places',
          examples: [
            {
              title: 'Format Price',
              syntax: 'SPA Price: RM {SPA_Price | formatnumber}',
              output: 'SPA Price: RM 1,500.00',
            },
          ],
        },
      ],
    },
    {
      title: "Purchaser's NRIC Format",
      sections: [
        {
          description: "Format purchaser's with '-'",
          examples: [
            {
              title: "Format Purchaser's NRIC",
              syntax: "Primary Purchaser's NRIC: {P1_ID_No | formatnric}",
              output: "Primary Purchaser's NRIC: 123456-78-9012",
            },
            {
              title: "Format Purchaser's NRIC with ID type checking",
              syntax: "Primary Purchaser's NRIC: {P1_ID_Type == 1 ? (P1_ID_No | formatnric) : P1_ID_No}",
              output: "Primary Purchaser's NRIC: 123456-78-9012",
            },
          ],
        },
      ],
    },
    {
      title: 'Booking and Unit Custom Fields Mergetag',
      sections: [
        {
          description: 'Display Booking and Unit custom fields',
          examples: [
            {
              title: "Booking Custom Field is built using its 'Field Label'",
              syntax: '{bcf_&lt;Field Label&gt;}. eg. SPA Solicitor Name: {bcf_SPA_Solicitor_Name}',
              output: 'SPA Solicitor Name: John Doe',
            },
            {
              title: "Unit Custom Field is built using its 'Field Label'",
              syntax: '{ucf_&lt;Field Label&gt;}. eg. Unit Name: {ucf_Unit_Name}',
              output: 'Unit Name: Unit A',
            },
          ],
        },
      ],
    },
    {
      title: 'Unit and Project Specification Mergetag',
      sections: [
        {
          description: 'Display unit and project specification fields',
          examples: [
            {
              title: 'Unit specification is built using it\'s \'Field Name\'',
              syntax: '{us_&lt;Field Name&gt;}. eg. SPA Solicitor Name: {us_SPA_Solicitor_Name}',
              output: 'SPA Solicitor Name: John Doe',
            },
            {
              title: 'Project specification is built using it\'s \'Field Name\'',
              syntax: '{ps_&lt;Field Name&gt;}. eg. Project Name: {ps_Project_Name}',
              output: 'Project Name: Project A',
            },
          ],
        },
      ],
    },
    {
      title: 'Variable Assignments/Declarations',
      sections: [
        {
          description: 'Create variable to store value and can be use within the template',
          examples: [
            {
              title: 'Direct Variable Assignment',
              syntax: '{@promoMerdekaAmount = 8000}\nPromo Merdeka Amount: {promoMerdekaAmount}',
              output: 'Promo Merdeka Amount: 8000',
            },
            {
              title: 'Variable Assignment in Pricing Package items (Promo Merdeka)',
              syntax: '{#Pricing_Package}\n{#Name == "Promo Merdeka" && IsEnabled}\n{@promoMerdekaAmount = ValueChange}\n{/}\n{/}\nPromo Merdeka Amount: {promoMerdekaAmount}',
              output: 'Promo Merdeka Amount: 8000',
            },
          ],
        },
      ],
    },
    {
      title: 'String to Int or Float Conversion',
      sections: [
        {
          description: 'Convert string to integer or float for mathematical operations',
          examples: [
            {
              title: 'Convert String to Int, eg. FormulaValue = \'5\'',
              syntax: 'FormulaValue: {FormulaValue | toInt}',
              output: 'FormulaValue: 5',
            },
            {
              title: 'Convert String to Float, eg. FormulaValue = \'5.5\'',
              syntax: 'FormulaValue: {FormulaValue | toFloat}',
              output: 'FormulaValue: 5.5',
            },
          ],
        },
      ],
    },
    {
      title: "Purchaser's Age by Birthdate",
      sections: [
        {
          description: "Get purchaser's age by birthdate",
          examples: [
            {
              title: "Get Purchaser's Age",
              syntax: "Primary Purchaser's Age: {P1_Birthdate | age}",
              output: "Primary Purchaser's Age: 35",
            },
          ],
        },
      ],
    },
    {
      title: 'Supported Fonts',
      sections: [
        {
          description: 'Ensure to use fonts are supported to avoid issues when generating forms',
        },
      ],
    },
  ],
};

const CONDITIONS_TAB = {
  text: 'Conditions',
  value: 'conditions',
  contents: [
    {
      title: 'Pricing Package Condition',
      sections: [
        {
          description: 'Purpose: To check if pricing package is not empty and list out all available pricing package (both enabled and disabled)',
          examples: [
            {
              // title: '',
              syntax: '{#Pricing_Package.length > 0}\n{#Pricing_Package}\nName: {Name | title}\nDescription: {Description}\nValue: {FormulaValue}\nNew Price: RM {NewValue | formatnumber}\nPrice Change: RM {ValueChange | formatnumber}\n{/}\n{/}',
              output: 'Name: Bumi Discount\nDescription: Discount for bumi buyer\nValue: 8\nNew Price: RM 230,000.60\nPrice Changes: RM 20,000.05',
            },
          ],
        },
        {
          description: 'Purpose: To check if pricing package is not empty and list out all enabled pricing package',
          examples: [
            {
              // title: '',
              syntax: '{#Pricing_Package.length > 0}\n{#Pricing_Package}\n{#IsEnabled}\nName: {Name | title}\nDescription: {Description}\nValue: {FormulaValue}\nNew Price: RM {NewValue | formatnumber}\nPrice Change: RM {ValueChange | formatnumber}\n{/}\n{/}\n{/}',
              output: 'Name: Bumi Discount\nDescription: Discount for bumi buyer\nValue: 8\nNew Price: RM 230,000.60\nPrice Changes: RM 20,000.05',
            },
          ],
        },
      ],
    },
    {
      title: 'Gender',
      sections: [
        {
          description: 'Purpose: To have a custom format for gender',
          examples: [
            {
              // title: '',
              syntax: '{#P1_Gender == "Male"} <u>M</u> / F{/}\n{^P1_Gender == "Male"} M / <u>F</u> {/}',
              output: 'M / <u>F</u>',
            },
          ],
        },
      ],
    },
  ],
};

const CHECKBOXES_TAB = {
  text: 'Checkboxes',
  value: 'checkboxes',
  contents: [
    {
      title: 'Booking Payment Method Checkbox',
      sections: [
        {
          description: 'Purpose: To tick on selected payment method',
          examples: [
            {
              // title: '',
              // syntax: '',
              syntaxImage: 'source_finance_checkbox_input.png',
              // output: '',
              outputImage: 'source_finance_checkbox_output.png',
            },
          ],
        },
      ],
    },
  ],
};

const LIST_TAB = {
  text: 'List / Tables',
  value: 'list_tables',
  contents: [
    {
      title: 'Direct usage of embedding mergetag in table',
      sections: [
        {
          description: 'Display purchaser name in a table',
          examples: [
            {
              syntaxImage: 'source_purchaser_name_table_input.png',
              outputImage: 'source_purchaser_name_table_output.png',
            },
          ],
        },
      ],
    },
    {
      title: 'Display Projectunit Specifications (Listing)',
      sections: [
        {
          description: 'Display projectunit specifications in a table',
          examples: [
            {
              syntaxImage: 'source_projectunitspecs_input.png',
              outputImage: 'source_projectunitspecs_output.png',
            },
          ],
        },
      ],
    },
    {
      title: 'Display Pricing Package in a table',
      sections: [
        {
          description: 'Display all Pricing Package',
          examples: [
            {
              syntaxImage: 'source_pricing_package_list_input.png',
              outputImage: 'source_pricing_package_list_output.png',
            },
          ],
        },
      ],
    },
  ],
};

const IMAGES_TAB = {
  text: 'Signatures',
  value: 'signatures',
  contents: [
    {
      title: 'Direct usage of purchaser signature mergetag',
      sections: [
        {
          description: 'Display purchaser signature image',
          examples: [
            {
              syntax: '{%P1_Signature}',
              outputImage: 'source_purchaser_signature_output.png',
            },
          ],
        },
      ],
    },
    {
      title: 'Purchaser signature with condition check',
      sections: [
        {
          description: 'Check if purchaser signature is available before displaying the image',
          examples: [
            {
              // title: '',
              syntax: '{#P1_Signature}{%P1_Signature}{/}',
              // syntaxImage: 'source_finance_checkbox_input.png',
              // output: '',
              outputImage: 'source_purchaser_signature_output.png',
            },
          ],
        },
      ],
    },
  ],
};


const DATE_TAB = {
  text: 'Date',
  value: 'date',
  contents: [
    {
      title: 'Date Formatting',
      sections: [
        {
          description: 'Format date into selected format',
          examples: [
            {
              syntax: '{Booking_CreatedAt | date:\'YYYY-MM-DD\'}',
              output: '2025-04-18',
            },
            {
              syntax: '{Booking_CreatedAt | date:\'DD-MM-YYYY\'}',
              output: '18-04-2025',
            },
            {
              syntax: '{Booking_CreatedAt | date:\'MM-DD-YYYY\'}',
              output: '04-18-2025',
            },
            {
              syntax: '{Booking_CreatedAt | date:\'DD-MMM-YYYY\'}',
              output: '18-Apr-2025',
            },
            {
              syntax: '{Booking_CreatedAt | date:\'MMM DD, YYYY\'}',
              output: 'Apr 18, 2025',
            },
            {
              syntax: '{Booking_CreatedAt | date:\'MMMM DD, YYYY\'}',
              output: 'April 18, 2025',
            },
            {
              syntax: '{Booking_CreatedAt | date:\'DD MMMM YYYY\'}',
              output: '18 April 2025',
            },
            {
              syntax: '{Booking_CreatedAt | date:\'YYYY/MM/DD\'}',
              output: '2025/04/18',
            },
            {
              syntax: '{Booking_CreatedAt | date:\'DD/MM/YYYY\'}',
              output: '18/04/2025',
            },
            {
              syntax: '{Booking_CreatedAt | date:\'MM/DD/YYYY\'}',
              output: '04/18/2025',
            },
          ],
        },
      ],
    },
    {
      title: 'Current Date Mergetag',
      sections: [
        {
          description: 'Mergetag to display current date',
          examples: [
            {
              syntax: '{currentDate}',
              output: '2025-09-18 10:49:30',
            },
            {
              syntax: 'Date formatter can be applied to this mergetag as well, e.g. {currentDate | date:\'DD-MM-YYYY\'}',
              output: '18-09-2025',
            },
            {
              syntax: '{currentYear}',
              output: '2025',
            },
            {
              syntax: '{currentMonth}',
              output: 'September',
            },
            {
              syntax: '{currentDay}',
              output: '18',
            },
          ],
        },
      ],
    },
  ],
};

const OPERATORS_TAB = {
  text: 'Operators',
  value: 'operators',
  contents: [
    {
      title: 'Supported Operators',
      sections: [
        {
          // description: 'Additional Operator, e.g. SPA_Price = 100000.00',
          description: 'General Operations',
          examples: [
            {
              title: 'Operation on raw number',
              syntax: '{SPA_Price + 50000.00}',
              output: '150000.00',
            },
            {
              title: 'Operation on mergetag',
              syntax: '{SPA_Price + SPA_Price}',
              output: '200000.00',
            },
          ],
        },
        {
          description: 'Additional Operator, e.g. SPA_Price = 100000.00',
          examples: [
            {
              title: 'Addition mergetag with raw number',
              syntax: '{SPA_Price + 50000.00}',
              output: '150000.00',
            },
            {
              title: 'Addition mergetag with mergetag',
              syntax: '{SPA_Price + SPA_Price}',
              output: '200000.00',
            },
            {
              title: 'Multiple Addition Operation',
              syntax: '{SPA_Price + SPA_Price + SPA_Price}',
              output: '300000.00',
            },
          ],
        },
        {
          description: 'Substraction Operator, e.g. SPA_Price = 100000.00, Discount = 10000.00',
          examples: [
            {
              title: 'Substraction mergetag with raw number',
              syntax: '{SPA_Price - 50000.00}',
              output: '50000.00',
            },
            {
              title: 'Substraction mergetag with mergetag',
              syntax: '{@Discount = 10000.00}\n{SPA_Price - Discount}',
              output: '90000.00',
            },
            {
              title: 'Multiple Substraction mergetag with mergetag',
              syntax: '{@Discount = 10000.00}\n{SPA_Price - Discount - 50000.00}',
              output: '40000.00',
            },
          ],
        },
        {
          description: 'Multiplication Operator, e.g. SPA_Price = 100000.00, Times = 5',
          examples: [
            {
              title: 'Multiplication mergetag with raw number',
              syntax: '{SPA_Price * 5}',
              output: '500000.00',
            },
            {
              title: 'Multiplication mergetag with mergetag',
              syntax: '{@Times = 5}\n{SPA_Price * Times}',
              output: '500000.00',
            },
            {
              title: 'Multiple Multiplication Operation',
              syntax: '{@Times = 5}\n{SPA_Price * Times * 5}',
              output: '2500000.00',
            },
          ],
        },
        {
          description: 'Division Operator, e.g. SPA_Price = 100000.00, DivNumber = 5',
          examples: [
            {
              title: 'Division mergetag with raw number',
              syntax: '{SPA_Price / 5}',
              output: '20000.00',
            },
            {
              title: 'Division mergetag with mergetag',
              syntax: '{@DivNumber = 5}\n{SPA_Price / DivNumber}',
              output: '20000.00',
            },
            {
              title: 'Multiple Division Operation',
              syntax: '{@DivNumber = 5}\n{SPA_Price / DivNumber / 5}',
              output: '4000.00',
            },
          ],
        },
      ],
    },
    {
      title: 'Pricing Package Operation Example',
      sections: [
        {
          description: 'Additional in Pricing Package Items',
          examples: [
            {
              title: 'Additional with single condition and field selection',
              syntax: "{Pricing_Package | where:'IsEnabled == true' | sumBy:'ValueChange'}",
              output: '500000.00',
            },
            {
              title: 'Additional with multiple condition and field selection',
              syntax: "{Pricing_Package | sumIf:'(Name == \"test1\" || Name == \"111\") && IsEnabled == true':'ValueChange'}",
              output: '500000.00',
            },
          ],
        },
      ],
    },
  ],
};

export const DOCX_TEMPLATE_SUPPORTED_FONTS = [
  'Arial',
  'Times New Roman',
  'Calibri',
  'Garamond',
  'Cambria',
  'Verdana',
  'Georgia',
  'Book Antiqua',
  'Tahoma',
  'Trebuchet MS',
];

const DOCX_TEMPLATE_GUIDES = [
  BASIC_TAB,
  CONDITIONS_TAB,
  CHECKBOXES_TAB,
  LIST_TAB,
  IMAGES_TAB,
  DATE_TAB,
  OPERATORS_TAB,
];

export default DOCX_TEMPLATE_GUIDES;



// WEBPACK FOOTER //
// ./src/constants/docxTemplate.js